import { inject } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { CoinDetail } from 'src/app/core/models/coin.model';
import { CoinService } from './coin.service';
import { EMPTY, catchError } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';

export const CoinDetailResolver: ResolveFn<CoinDetail> = (
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
) => {
    const coinService = inject(CoinService);
    const errorService = inject(ErrorHandlerService);
    const coinCode: string = route.paramMap.get('coinCode')!.toUpperCase();
    return coinService.fetchCoinDetail(coinCode).pipe(
        catchError(_ => {
            errorService.handleInvalidCoin(coinCode);
            return EMPTY;
        })
    );
};
